









import { BaseSelect, selectName } from '#components/baseSelect';

import { apiProvider } from '../api';
import { NAME } from '../constants';

export default BaseSelect.extend({
	name: selectName(NAME),
	props: {
		labelKey: { type: String, default: 'SKLADMISTO_ID' },
	},
	data() {
		return {
			storeObject: NAME,
			valueFieldName: 'SKLADMISTO',
			apiProvider,
			emptyObject: { id: null, value: null, text: null },
		};
	},
	methods: {
		dbToBaseMapper(data: Record<string, any>) {
			return {
				id: data.SKLADMISTO_ID,
				value: data.SKLADMISTO,
				text: data.POPIS,
			};
		},
	},
});
